// Web module: personnel (people lane). The Personnel list at Drata parity (one icon column per compliance check, facets,
// filters, reminders, exclusions, CSV) and the person detail tabs (Compliance checks, Devices, Identities, Policies,
// Training, Background check) next to the generic Overview and History. The contract is in ../README.md.
import { lazyComponent } from '../../lib/lazy'
import type { WebModule } from '../../lib/modules'

export const module: WebModule = {
  routes: [],
  entityOverrides: {
    personnel: {
      ListPage: lazyComponent(() => import('./PersonnelListPage'), 'PersonnelListPage'),
      // The generic detail page with the directory sync banner (Managed by Entra, Re-enable sync, Resync now) above it.
      DetailPage: lazyComponent(() => import('./PersonDetailPage'), 'PersonDetailPage'),
      detailTabs: [
        {
          id: 'checks',
          label: 'Compliance checks',
          order: 12,
          component: lazyComponent(() => import('./PersonTabs'), 'ChecksTab'),
        },
        {
          id: 'devices',
          label: 'Devices',
          order: 13,
          component: lazyComponent(() => import('./PersonTabs'), 'DevicesTab'),
        },
        {
          id: 'identities',
          label: 'Identities',
          order: 14,
          component: lazyComponent(() => import('./PersonTabs'), 'IdentitiesTab'),
        },
        {
          id: 'policies',
          label: 'Policies',
          order: 15,
          component: lazyComponent(() => import('./PersonTabs'), 'PoliciesTab'),
        },
        {
          id: 'training',
          label: 'Training',
          order: 16,
          component: lazyComponent(() => import('./PersonTabs'), 'TrainingTab'),
        },
        {
          id: 'background',
          label: 'Background check',
          order: 17,
          component: lazyComponent(() => import('./PersonTabs'), 'BackgroundTab'),
        },
      ],
      hideDefaultTabs: ['links'],
    },
  },
}
